import { queryWatchlistListings } from '../LandingPage/LandingPage.duck';

export const loadData = () => (dispatch, getState, sdk) => {
  return dispatch(queryWatchlistListings());
};
